if (!customElements.get('footer-accordion')) {
  customElements.define(
    'footer-accordion',
    class FooterAccordion extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.footer-block__toggle');
        if (!this.button) return;
        this.mql = window.matchMedia('(max-width: 749px)');
        this.sync = () => this.button.setAttribute('aria-expanded', String(!this.mql.matches));
        this.sync();
        this.mql.addEventListener('change', this.sync);
        this.button.addEventListener('click', () => {
          if (!this.mql.matches) return;
          const expanded = this.button.getAttribute('aria-expanded') === 'true';
          this.button.setAttribute('aria-expanded', String(!expanded));
        });
      }

      disconnectedCallback() {
        this.mql && this.mql.removeEventListener('change', this.sync);
      }
    }
  );
}
